<script setup>
    import CookiesBody from './CookiesBody.vue';
</script>
<template>
    <div class="w-100 custom-inner-view container-cookies-wrapper">
        <div class="container">
            <CookiesBody />
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .container-cookies-wrapper {
        background: rgb(255,255,255);
        background: linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(224,228,233,1) 100%);
    }
</style>